import React from 'react';
import { useTranslation } from 'react-i18next';
import GenericTablePage from '../components/GenericTablePage';
import { GridColDef } from '@mui/x-data-grid';
import { formatDate } from '../lib/dateUtils';

const EventsPage: React.FC = () => {
  const { t, i18n } = useTranslation();
  const locale = i18n.language === 'ar' ? 'ar' : 'en';
  
  const columns: GridColDef[] = [
    { field: 'title', headerName: t('events.eventTitle'), flex: 1, minWidth: 250 },
    { 
      field: 'start_date', 
      headerName: t('events.startDate'), 
      width: 150,
      valueFormatter: (value) => formatDate(value, locale, 'medium'),
    },
    { 
      field: 'end_date', 
      headerName: t('events.endDate'), 
      width: 150,
      valueFormatter: (value) => formatDate(value, locale, 'medium'),
    },
  ];

  const fields = [
    { 
      name: 'title', 
      label: t('events.eventTitle'), 
      type: 'text' as const, 
      required: true 
    },
    { 
      name: 'details', 
      label: t('events.details'), 
      type: 'textarea' as const, 
      required: true 
    },
    { 
      name: 'start_date', 
      label: t('events.startDate'), 
      type: 'date' as const, 
      required: true 
    },
    {
      name: 'end_date',
      label: t('events.endDate'),
      type: 'date' as const
    },
    {
      // Event locations -> events.cities (jsonb array of city ids).
      name: 'cities',
      label: t('events.cities'),
      type: 'multiselect' as const,
      width: 'full' as const,
      foreignKey: { table: 'cities', valueField: 'id', labelField: 'translation,city' },
    },
  ];

  return (
    <GenericTablePage 
      tableName="events"
      title={t('events.title')}
      columns={columns}
      fields={fields}
    />
  );
};

export default EventsPage;
